import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { EchartService } from '../../../../core/services/echart.service';
import { ToastrService } from 'ngx-toastr';
import { graphic } from 'echarts';


@Component({
    selector: 'app-year-trend',
    templateUrl: './year-trend.component.html',
    styleUrls: ['./year-trend.component.scss']
})

export class YearTrendComponent implements OnInit, AfterViewInit {
    @ViewChild('myCharts') myCharts: ElementRef;
    @Input() projectId: any;
    echartsInstance: any;
    selectedYearNum = 5;

    yearNums = [
        {
            value: 2,
            desc: 'Recent 2 years'
        }, {
            value: 3,
            desc: 'Recent 3 years'
        }, {
            value: 4,
            desc: 'Recent 4 years'
        },
        {
            value: 5,
            desc: 'Recent 5 years'
        },
        {
            value: 6,
            desc: 'Recent 6 years'
        },
        {
            value: 7,
            desc: 'Recent 7 years'
        },
        {
            value: 8,
            desc: 'Recent 8 years'
        },
        {
            value: 9,
            desc: 'Recent 9 years'
        },
        {
            value: 10,
            desc: 'Recent 10 years'
        }];

    chartOption = {
        grid: {
            top: '120px',
            right: '40px',
            left: '40px',
            bottom: '60px'
        },
        color: ['#5121d3', '#05CD99'],
        title: {
            text: 'Yearly Property Stats',
            top: '30px',
            left: '20px',
            textStyle: {
                fontFamily: 'Roboto',
                fontSize: 10
            }
        },
        legend: {
            data: ['Sold', 'Settled'],
            left: '20px',
            top: '60px',
            textStyle: {
                color: '#a3a3a3'
            }
        },
        tooltip: {
            trigger: 'axis'
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     saveAsImage: {show: true}
        //   }
        // },
        xAxis: {
            type: 'category',
            offset: 2,
            // boundaryGap: false,
            // data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            data: [],
            axisLine: {
                show: false
            },
            axisLabel: {
                color: '#cccccc',
                fontFamily: 'Poppins Regular'
            },
            axisTick: {
                show: false
            },
        },
        yAxis: {
            // type: 'value'
            interval: '20',
            minInterval: '20',
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#cccccc',
                fontFamily: 'Poppins Regular'
            },
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: '#eaeaea',
                    dashOffset: '5'
                }
            }
        },
        series: [
            {
                name: 'Sold',
                data: [],
                type: 'line',
                symbol: 'circle',
                smooth: true,
                areaStyle: {
                    color: new graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(81,33,211,0.59)'
                    }, {
                        offset: 1,
                        color: 'rgba(81,33,211,0.18)'
                    }])
                },
                lineStyle: {
                    color: '#5121d3'
                }
            },
            {
                name: 'Settled',
                data: [],
                type: 'line',
                symbol: 'circle',
                smooth: true,
                areaStyle: {
                    color: new graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#05CD99'
                    }, {
                        offset: 1,
                        color: 'rgba(5,205,153,0.12)'
                    }])
                },
                lineStyle: {
                    color: '#05CD99'
                }
            }
        ]
    };


    constructor(private echartService: EchartService, private toastrService: ToastrService) {
        this.selectedYearNum = 5;
    }


    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.selectYearNum(this.selectedYearNum);
    }

    public selectYearNum(e: any): void {
        console.log(e);
        this.echartService.getPropertySaleChangeByYear(e, this.projectId).subscribe((res: any) => {
            console.log(res);
            if (res.code === 1) {
                this.chartOption.series[0].data = [];
                this.chartOption.series[1].data = [];
                this.chartOption.xAxis.data = [];
                for (const k in res.data.sold) {
                    this.chartOption.xAxis.data.push(k);
                }
                for (const k in res.data.sold) {
                    // sold.push(res.data.sold[k]);
                    this.chartOption.series[0].data.push(res.data.sold[k]);
                }
                for (const k in res.data.settle) {
                    // settle.push(res.data.settle[k]);
                    this.chartOption.series[1].data.push(res.data.settle[k]);
                }
                if (this.echartsInstance) {
                    this.echartsInstance.setOption(this.chartOption);
                }
            } else {
                // this.toastrService.warning('Sorry, failed to get data');
            }
        });

    }





    onChartInit(ec) {
        console.log(ec);
        // ec.resize();
        this.echartsInstance = ec;
    }
}
